import { NgModule, APP_INITIALIZER } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import './models/rxjs-operators'

// custom modules
import { AppRoutingModule } from './app-routing.module'
import { SharedModule } from './modules/shared/shared.module'
import { InitializeService } from './services/initialize.service'

// guards
import { AdminGuard } from './guards/admin.guard'
import { CustomerGuard } from './guards/customer.guard'

// shared components
import { AppComponent } from './com/app/app.com'
import { SideMenuComponent } from './com/side-menu/side-menu.com'
import { FooterComponent } from './com/footer/footer.com'
import { HomeComponent } from './com/home/home.com'
import { TopBarComponent } from './com/top-bar/top-bar.com'
import { FullScreenMenuComponent } from './com/full-screen-menu/full-screen-menu.com'
import { NavigationComponent } from './com/navigation/navigation.com'
import { LoaderComponent } from './com/loader/loader.com'
import { SnackbarComponent } from './com/snackbar/snackbar.com'

// ngrx
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { AppReducer } from './store/app.reducer'
import { AppEffects } from './store/app.effects'

export function sessionServiceFactory(initialize: InitializeService): Function {
  return () => initialize.logInByToken()
}

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    StoreModule.forRoot(<any>{ app: AppReducer }),
    EffectsModule.forRoot([ AppEffects ])
  ],
  providers: [
    { provide: APP_INITIALIZER, useFactory: sessionServiceFactory, deps: [ InitializeService ], multi: true },
    InitializeService,
    AdminGuard,
    CustomerGuard,
    AppEffects
  ],
  declarations: [
    AppComponent,
    SideMenuComponent,
    FooterComponent,
    HomeComponent,
    TopBarComponent,
    FullScreenMenuComponent,
    NavigationComponent,
    LoaderComponent,
    SnackbarComponent
  ],
  bootstrap: [ AppComponent ]
})

export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts